export default {
  "Add product": "Ajouter un produit",
  "High Stock": "Stock élevé",
  "Medium Stock": "Stock moyen",
  "Low stock": "Stock faible",
  "Out of stock": "Rupture de stock",
  "Out of Stock": "Rupture de stock",
  "FIFO (First-In, First-Out)": "FIFO (Premier entré, premier sorti)",
  "LIFO (Last-In, First-Out)": "LIFO (Dernier entré, premier sorti)",
  "Average Cost": "Coût moyen pondéré",
  Product: "Produit",
  Category: "Catégorie",
  "Selling Price": "Prix de vente",
  Quantity: "Quantité",
  Status: "Statut",
  Actions: "Actions",
  "Total Sold": "Total vendu",
  Revenue: "Chiffre d'affaires",
  SKU: "Référence (SKU)",
  "N/A": "N/A",
  "Reorder Point": "Point de commande",
  "Current Total Qty": "Quantité totale actuelle",
  Change: "Modifier",
  "Search product or shop name": "Rechercher un produit ou une boutique",
  Price: "Prix",
  "No product-shops found": "Aucun produit trouvé",
  Information: "Informations",
  "Product name": "Nom du produit",
  "Product SKU": "Référence (SKU)",
  "Product Description": "Description du produit",
  "Product Type": "Type de produit",
  "Product Category": "Catégorie de produit",
  "Pricing & Status": "Prix et Statut",
  "Valuation Method": "Méthode de valorisation",
  "Stock Tracking": "Suivi des stocks",
  "Minimum Stock Level": "Niveau de stock minimum",
  "Maximum Stock Level": "Niveau de stock maximum",
  "Product Unit Type": "Unité de mesure",
  "Featured image": "Image mise en avant",
  Images: "Galerie d'images",
  "Do you really want to delete this Product Price?":
    "Voulez-vous vraiment supprimer le prix de ce produit ?",
  "Warning: This action is irreversible and will remove this price and stock configuration for the selected shop.":
    "Attention : cette action est irréversible et supprimera la configuration du prix et du stock pour la boutique sélectionnée.",
  Cancel: "Annuler",
  "Confirm Deletion": "Confirmer la suppression",
  "Product edit with success": "Produit modifié avec succès",
  Back: "Retour",
  "Edit product": "Modifier le produit",
  "Save changes": "Enregistrer les modifications",
};
